<template>
  <div
    class="video-thumbnail-inline"
    :class="getVariant('video-thumbnail-inline')"
    @click="clickVideo"
  >
    <!-- Image -->
    <figure
      v-show="!playing"
      class="video-thumbnail-inline__image"
    >
      <slot name="image" />

      <!-- Icon -->
      <div class="video-thumbnail-inline__icon">
        <icon-play-view
          class="animate"
          :has-title="false"
          :loading="loading"
        />
      </div>
    </figure>

    <!-- Video -->
    <div
      v-show="playing"
      class="video-thumbnail-inline__video"
    >
      <video-fullscreen-inline-view
        :video-id="videoId"
        :loading="loading"
        @start-playing="onStartPlaying()"
        @stop-playing="onStopPlaying()"
      />
    </div>
  </div>
</template>

<script>
import variant from '@/mixins/variant';

export default {
  name: 'VideoThumbnailInline',

  components: {
    VideoFullscreenInlineView: () => import('./video-fullscreen-inline-view'),
    IconPlayView: () => import('@/icons/icon-play-view')
  },

  mixins: [variant],

  props: {
    videoId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      playing: false
    };
  },

  methods: {
    clickVideo() {
      this.loading = true;
    },

    onStartPlaying() {
      this.playing = true;
    },

    onStopPlaying() {
      this.loading = false;
      this.playing = false;
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/video/video-thumbnail-inline-view.scss"></style>



// WEBPACK FOOTER //
// video-thumbnail-inline-view.vue